import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import AppContext from 'containers/App/Store/AppContext'
import {
  useGetDebtorTypeQuery,
  useGetCompanyNameQuery,
  useGetDebtorAccountLazyQuery,
  useGetAssignedCompanyQuery,
  useGetDebtorAccountListingLazyQuery,
} from 'generated/graphql'
import React, { useContext, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import * as yup from 'yup'
import { CommonYupValidation } from 'helpers/Form/YupValidation'

interface ARDebtorAgingSummarybyTrxDateParamsProps {
  CompanyID: string
  DocDate: Date
  DebtorAccountID: string
  DebtorTypeID: string
}

interface CompanyOption {
  Name: string
  CompanyID: string
}

export const ARDebtorAgingSummarybyTrxDateParamsForm = (props: any) => {
  const { globalState, dispatch }: any = useContext(AppContext as any)
  let history = useHistory()
  const { CompanyID }: any = useParams()
  let location = useLocation()
  const editData = location?.state as any
  const latestCompany = localStorage.getItem('latestCompany')
  const ParamsSchema = yup.object().shape({
    CompanyID: CommonYupValidation.requireField('Company is required'),
  })

  const {
    handleSubmit,
    register,
    errors,
    control,
    getValues,
    watch,
    setValue,
  } = useForm<ARDebtorAgingSummarybyTrxDateParamsProps>({
    defaultValues: {},
    mode: 'all',
    resolver: yupResolver(ParamsSchema),
  })

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  // ACCOUNTX API CALLS

  const {
    loading: CompanyLoading,
    error: CompanyError,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    variables: { CompanyID },
    fetchPolicy: 'network-only',
    onCompleted: () => {
      if (latestCompany) {
        loadDebtorAccount({
          variables: {
            CompanyID: latestCompany,
          },
        })
      }
    },
  })

  const {
    loading: CompanyAssignedLoading,
    error: CompanyAssignedError,
    data: { getAssignedCompanyByUser } = { getAssignedCompanyByUser: [] },
  } = useGetAssignedCompanyQuery({
    fetchPolicy: 'network-only',
    onCompleted: () => {
      if (latestCompany) {
        loadDebtorAccount({
          variables: {
            CompanyID: latestCompany,
          },
        })
      }
    },
  })

  const [
    loadDebtorAccount,
    {
      loading: DebtorAccountLoading,
      data: { getDebtorAccountListing } = { getDebtorAccountListing: [] },
    },
  ] = useGetDebtorAccountListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: DebtorTypeLoading,
    error: DebtorTypeErrors,
    data: { getDebtorType } = { getDebtorType: [] },
  } = useGetDebtorTypeQuery({
    fetchPolicy: 'network-only',
    variables: {},
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const onSubmit = (data, status) => {
    console.log(data, 'data')

    history.push({
      pathname: `/digital-reports/account-receivable/ar-debtor-aging-summary-trx-date/generated`,
      state: {
        CompanyID: data?.CompanyID,
        DocDate: new Date(data.DocDate),
        DebtorTypeID: data.DebtorTypeID ? data.DebtorTypeID : undefined,
        DebtorAccountID: data.DebtorAccountID
          ? data.DebtorAccountID
          : undefined,
      },
    })
  }
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  return (
    <>
      {CompanyLoading && <Loading />}
      {DebtorTypeLoading && <Loading />}
      {DebtorAccountLoading && <Loading />}
      {CompanyAssignedLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => history.push(`/digital-reports/account-receivable`)}
        smTitle={'Account Receivable'}
        title={user?.accountName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Submenu' },
          { name: 'Debtor Aging Summary by Transaction Date', current: true },
        ]}
        rightRouteSegments={[{ name: 'Parameters', current: true }]}
      />
      <ContentWrapper float>
        <CardContents>
          {!CompanyAssignedLoading && !CompanyLoading && (
            <Controller
              render={({ value, onChange }) => {
                const options: CompanyOption[] =
                  !!user?.superUser === false
                    ? getAssignedCompanyByUser
                    : getCompany
                const defVal = getCompany?.filter(
                  x => x?.CompanyID === latestCompany
                )[0]
                return (
                  <Autocomplete
                    options={options || []}
                    getOptionLabel={(option: CompanyOption) => option.Name}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      setValue('CompanyID', newValue?.CompanyID)

                      loadDebtorAccount({
                        variables: {
                          CompanyID: newValue?.CompanyID,
                        },
                      })
                    }}
                    renderOption={(props, option) => {
                      return <span>{props?.Name}</span>
                    }}
                    defaultValue={defVal}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.CompanyID?.message}
                            error={errors?.CompanyID ? true : false}
                            label="Company"
                            style={{ width: '100%' }}
                            margin="normal"
                            required
                            defaultValue={defVal}
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              label="Company"
              name="CompanyID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="normal"
              ref={register}
              helperText={errors?.CompanyID?.message}
              error={errors?.CompanyID ? true : false}
              required
              defaultValue={latestCompany}
            />
          )}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              required
              as={KeyboardDatePicker}
              name="DocDate"
              label="Transaction Date"
              control={control}
              onChange={(date: Date | null) => {}}
              format="dd/MM/yyyy"
              value={watch('DocDate')}
              margin="normal"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              defaultValue={editData?.DocDate ?? new Date()}
              helperText={errors?.DocDate?.message}
              error={errors?.DocDate ? true : false}
              showTodayButton
              fullWidth
            />
          </MuiPickersUtilsProvider>

          {console.log(watch(`DebtorAccountID`), 'watch')}

          <Controller
            render={({ value, onChange }) => {
              return (
                <Autocomplete
                  options={getDebtorType || []}
                  getOptionLabel={option => `${option?.Name}`}
                  fullWidth
                  onChange={(value, newValue: any) => {
                    setValue('DebtorTypeID', newValue?.DebtorTypeID)
                  }}
                  renderOption={(props, option) => {
                    return <span>{props?.Name}</span>
                  }}
                  renderInput={(params: any) => {
                    return (
                      <div>
                        <TextField
                          {...params}
                          helperText={errors?.DebtorTypeID?.message}
                          error={errors?.DebtorTypeID ? true : false}
                          label="Debtor Type"
                          style={{ width: '100%' }}
                          margin="normal"
                        />
                      </div>
                    )
                  }}
                />
              )
            }}
            label="Debtor Type"
            name="DebtorTypeID"
            autoComplete="off"
            control={control}
            multiline={true}
            fullWidth
            margin="normal"
            ref={register}
            helperText={errors?.DebtorTypeID?.message}
            error={errors?.DebtorTypeID ? true : false}
          />

          <Controller
            render={({ value, onChange }) => {
              return (
                <Autocomplete
                  options={getDebtorAccountListing || []}
                  getOptionLabel={option => `${option?.DebtorName}`}
                  fullWidth
                  onChange={(value, newValue: any) => {
                    setValue('DebtorAccountID', newValue?.DebtorAccountID)
                  }}
                  renderOption={(props, option) => {
                    return <span>{props?.DebtorName}</span>
                  }}
                  renderInput={(params: any) => {
                    return (
                      <div>
                        <TextField
                          {...params}
                          helperText={errors?.DebtorAccountID?.message}
                          error={errors?.DebtorAccountID ? true : false}
                          label="Debtor Account"
                          style={{ width: '100%' }}
                          margin="normal"
                        />
                      </div>
                    )
                  }}
                />
              )
            }}
            label="Debtor Account"
            name="DebtorAccountID"
            autoComplete="off"
            control={control}
            multiline={true}
            fullWidth
            margin="normal"
            ref={register}
            helperText={errors?.DebtorAccountID?.message}
            error={errors?.DebtorAccountID ? true : false}
          />
        </CardContents>

        <AccountFooter
          options={[
            {
              name: 'Submit',
              onClick: () => {
                handleSubmit(onSubmit)()
              },
              color: 'primary',
            },
          ]}
        />
      </ContentWrapper>

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
